/*
 * @Author: Nora Galvin
 * @Date: 2020-08-21 15:28:07
 * @Last Modified by: Nora
 * @Last Modified time: 2020-09-16 10:59:40
 */
import type { TypeAnimation, TypeSetting, TypeOption } from '../type';

/**
 * renderSelect
 * @param settings ..
 * @param inputType ..
 * @returns string
 */
function renderSelect(settings: TypeSetting, inputType?: string): string {
  let optionsTemplate = '';
  settings.options.forEach((el) => {
    optionsTemplate += `<option class="gf-dropdown-item" value="${el.key}" ${
      settings.value == el.key ? 'selected' : ''
    }>${el.value}</option>`;
  });

  const templateBody = `
  <select data-key="${settings.key}" data-inputtype="${inputType}">
    ${optionsTemplate}
  </select>
  `;

  const template = `
      <div class="interaction-section">
        <p class="title">${settings.title}</p>
        ${templateBody}
      </div>
    `;
  return template;
}

/**
 * Template settings
 * @param settings ..
 * @returns string
 */
function settingsTemplate(settings: Array<TypeSetting> | undefined): string {
  let template = '';
  settings?.forEach((e) => {
    switch (e.type) {
      case 'select':
        template += renderSelect(e, 'settings');
        break;
    }
  });
  return template;
}

/**
 * Render Slider option
 * @param option ..
 * @param inputType ..
 * @returns string
 */
function renderSlider(option: TypeOption, inputType?: string): string {
  let template = '';
  template += `
    <div class="interaction-section">
      <p class="title">${option.name}</p>
      <input data-inputtype="${inputType}" data-type="${option.type}" data-type="slider" data-key="${
    option.key
  }" data-min="${option.min}" data-max="${option.max}" data-step="${option.step || 1}" data-valuetype="${
    option['value-type']
  }" value="${option.value}"/>
    </div>
  `;
  return template;
}

/**
 * Render Checkbox
 * @param option ..
 * @param inputType ..
 * @returns string
 */
function renderCheckBox(option: TypeOption, inputType?: string): string {
  let template = '';
  let templateBody = '';
  option.options?.forEach((e) => {
    let checked = '';
    if (e.value) {
      checked = 'checked';
      if (e.key == 'iteration' && e.value == 1) {
        checked = '';
      }
    }
    templateBody += `
      <div class="checkbox-wrapper">
        <label>
          <input data-inputtype="${inputType}" type="checkbox" data-type="checkbox" name="${option.key}" data-key="${e.key}" data-value="${e.name}" value="${e.key}" ${checked}/>
          ${e.name}
        </label>
      </div>
    `;
  });
  template += `
    <div class="interaction-section">
      <p class="title">${option.name}</p>
      <div class="checkbox-group">
        ${templateBody}
      </div>
    </div>
  `;
  return template;
}

/**
 * Render delay
 * @param options ...
 * @returns string
 */
function renderOptions(options: Array<TypeOption> | undefined): string {
  let template = '';
  options?.forEach((option) => {
    switch (option.type) {
      case 'slider':
        template += renderSlider(option, 'options');
        break;

      case 'checkbox':
        template += renderCheckBox(option, 'options');
        break;

      case 'select':
        break;

      case 'input':
        break;
    }
  });
  return template;
}

/**
 * Button Template
 * @returns string
 */
function buttonsHTML(): string {
  return `
    <div class="button-group">
      <button class="view-animation">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 12.2338V3.76619C3 2.9889 3.84797 2.50878 4.5145 2.9087L11.5708 7.14251C12.2182 7.53091 12.2182 8.46909 11.5708 8.85749L4.5145 13.0913C3.84797 13.4912 3 13.0111 3 12.2338Z" fill="#F8F8F8"/>
        </svg>

        <svg style="display: none" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="9.59998" y="1.59998" width="2.4" height="12.8" fill="#F8F8F8"/>
          <rect x="4" y="1.59998" width="2.4" height="12.8" fill="#F8F8F8"/>
        </svg>

        <p>View Animation</p>
      </button>
      
      <!-- Currently disable this button until have auto save editor
        <button class="view-live">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0)">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99989 3.0005C10.8961 2.95561 13.7992 4.9559 15.5858 6.92014L15.5874 6.92192C16.1386 7.53386 16.1386 8.46326 15.5874 9.0752L15.2159 8.74056L15.5859 9.07681C13.8401 10.9982 10.9441 13.0442 7.99989 12.9986C5.05568 13.0442 2.16031 10.9982 0.415702 9.07666L0.414374 9.0752L0.414377 9.0752C-0.136824 8.46327 -0.136823 7.53386 0.414377 6.92193L0.785885 7.25656L0.415805 6.92035C2.20051 4.95588 5.10364 2.95561 7.99989 3.0005ZM1.15678 7.59188C2.86505 5.71192 5.51622 3.95874 7.99145 4.00049L7.99989 3.50056L8.00832 4.00049C10.4835 3.95874 13.1346 5.71182 14.845 7.59194C15.0527 7.82324 15.0527 8.17391 14.845 8.40521C13.1712 10.247 10.5275 12.041 8.0083 11.9986H7.99147C5.4723 12.041 2.8293 10.247 1.15686 8.40533C0.949042 8.17402 0.949015 7.82323 1.15678 7.59188Z" fill="#F8F8F8"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M10 7.99753C9.99941 6.89333 9.10381 5.99868 7.9996 5.99927L7.99933 5.49927L7.99947 5.99927C6.8951 5.99956 6 6.8949 6 7.99927C6 9.10384 6.89543 9.99927 8 9.99927C9.10435 9.99927 9.99964 9.1042 10 7.99993C10 7.99971 10 7.99949 10 7.99927C10 7.99904 10 7.9988 10 7.99857C10 7.99822 10 7.99788 10 7.99753ZM11 7.99927C11 7.99851 11 7.99776 11 7.997C10.9991 6.34056 9.65563 4.99846 7.9992 4.99927M11 8.0005C10.9993 9.65679 9.65644 10.9993 8 10.9993C6.34314 10.9993 5 9.65612 5 7.99927C5 6.34277 6.34258 4.99978 7.99907 4.99927" fill="#F8F8F8"/>
            </g>
            <defs>
            <clipPath id="clip0">
            <rect width="16" height="16" fill="white"/>
            </clipPath>
            </defs>
          </svg>        
        </button>
      -->
    </div>
  `;
}

/**
 * Render setting to template
 * @param animation ..
 * @returns string
 */
export default (animation: TypeAnimation): string => {
  let template = '';
  const settingsHTML = settingsTemplate(animation.settings);
  const optionsHTML = renderOptions(animation.options);

  template += settingsHTML + optionsHTML + buttonsHTML();
  return template;
};
